export const COLORS = {
  lightGreen: '#a8d17b',
};
